import { IoCheckmarkCircle } from 'react-icons/io5';

export default function FieldVerifiedIcon({ label = 'Verificado' }: { label?: string }) {
  return (
    <span
      className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-emerald-600"
      title={label}
    >
      <IoCheckmarkCircle className="h-5 w-5" aria-hidden />
      <span className="sr-only">{label}</span>
    </span>
  );
}
